import { cn } from '../../utils/cn'

const VARIANT_CLASSES = {
  primary:
    'bg-gradient-to-b from-emerald-500 to-emerald-600 text-white shadow-sm hover:from-emerald-500 hover:to-emerald-700',
  secondary:
    'bg-slate-900 text-white shadow-sm hover:bg-slate-800',
  outline:
    'bg-white text-slate-900 border border-slate-200 hover:border-slate-300 hover:bg-slate-50',
  ghost: 'bg-transparent text-slate-700 hover:bg-slate-100',
  danger:
    'bg-gradient-to-b from-rose-500 to-rose-600 text-white shadow-sm hover:from-rose-500 hover:to-rose-700'
}

const SIZE_CLASSES = {
  sm: 'h-9 px-3 text-sm rounded-lg',
  md: 'h-11 px-4 text-sm rounded-xl',
  lg: 'h-12 px-5 text-base rounded-xl'
}

export default function Button({
  className,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  type = 'button',
  children,
  ...props
}) {
  const isDisabled = disabled || loading

  return (
    <button
      type={type}
      disabled={isDisabled}
      className={cn(
        'inline-flex items-center justify-center gap-2 font-semibold',
        'transition-all duration-200 ease-out',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white',
        'disabled:opacity-60 disabled:pointer-events-none',
        'active:translate-y-[1px]',
        VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary,
        SIZE_CLASSES[size] || SIZE_CLASSES.md,
        className
      )}
      {...props}
    >
      {loading ? <span className="loading loading-spinner loading-sm" /> : null}
      {children}
    </button>
  )
}

